<template>
  <generic-modal
    size="small"
    :title="$t('edit product quotation')"
    icon="edit"
    image="/images/icons/edit.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form">
        <h4 class="ui dividing header">{{ $t("order information") }}</h4>
        <div class="three fields">
          <div class="field">
            <label for>{{ $t("quantity") }}</label>
            <input type="text" name="quantity" v-model="itm.quantity" />
          </div>
          <div class="field">
            <label for>{{ $t("quotation price") }}</label>
            <input type="text" name="sale_price" v-model="itm.sale_price" />
          </div>
          <div class="field">
            <label for>{{ $t("discount") }}</label>
            <input type="text" name="discount" v-model="itm.discount_percentage" />
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import _ from "lodash";

export default {
  components: {
    "generic-modal": GenericModal
  },
  props: {
    item: Object
  },
  computed: {},
  data() {
    return {
      itm: {}
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve) {
        vm.$emit("finished", vm.itm);
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    if (vm.item) {
      vm.itm = _.clone(vm.item);
    }
  },
  watch: {},
  updated: function() {}
};
</script>
